import axios from 'axios';

import config from '../utils/config';

export const fetchBotConfigApi = (botId) => {
    return axios({
        method: 'get',
        url: config.getBotConfig(botId),
        headers: {
            'Content-type': 'application/json'
        }
    })
};

export const fetchChatSurveyConfigApi = (botId, relayState = '') => {
    return axios({
        method: 'get',
        url: config.getChatSurveyConfig(botId, relayState),
        headers: {
            'Content-type': 'application/json'
        }
    })
};

export const postChatSurveyConfigApi = (botId, data, relayState = '') => {
    return axios({
        method: 'post',
        url: config.submitChatSurveyConfig(botId, relayState),
        headers: {
            'Content-type': 'application/json'
        },
        data: data
    })
};

export const fetchChatOnlyBotApi = () => {
    return axios({
        method: 'get',
        url: config.getChatOnlyBot,
        headers: {
            'Content-type': 'application/json'
        }
    })
};

export const fetchQueueList = (botId, relayState = '') => {
    return axios({
        method: 'get',
        url: config.getQueueList(botId, relayState),
        headers: {
            'Content-type': 'application/json'
        }
    })
};